import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// ====================================================================
// ziven-theme-aura v0.2.5f mobileComposer.js
// ====================================================================
//
// 移动端 (< 992px) 帖子页 composer 改 fixed bottom 仿小黑盒, 1:1 复刻设计图 v4
//   - 范围: DiscussionPage 移动端 composer, 桌面端保留 vendor 默认
//   - 范围明确: 只针对移动端, 只改 composer UI 和位置, 帖子本身样式不动
//   - 配套: zpc v0.1.0e.k 系列已经 revert 干净 (e.j 状态), 跟本扩展不冲突
//
// 设计 v4 (辉哥 20:14 拍板, 必须 1:1 复刻):
//   - /Users/zhaozihui/.mavis/agents/mavis/workspace/ziven-theme-aura-v4-{default,focused,overview}.png
//   - /Users/zhaozihui/.mavis/agents/mavis/workspace/ziven-theme-composer-design/index.html
//   - Default 状态 (80px): "来说点什么吧!" 输入框 (pill 形状 20px 圆角) + 2 action
//     (👍 点赞 1313 + ⭐ 书签 112 fof/bookmarks 可选)
//   - Focused 状态 (140px): 大输入框 (~80px 高, 4-5 行) 内嵌右下 4 input-tool
//     (😊/🖼️/@/发送) + 8 emoji 工具条 (😊 😢 😨 🤔 😱 😺 🥵 🧢)
//   - 容器: position: fixed; bottom: 0; 黑底透明 + backdrop-filter: blur(20px)
//   - vendor Composer 子元素全部 hidden (Composer-controls / Composer-handle /
//     Composer-content / ComposerBody-avatar / TextEditor-controls 全部 display:none)
//
// 实施策略 (SOP 271 + 280 实战模式, 跟 zpc e.k 同款):
//   1. override vendor Composer.view (chunk 366 module 8139 lazy chunk, SOP 280
//      走 flarum.reg.onLoad 拿 class, 不能直接 import)
//   2. override vendor Composer.oncreate: 跳过 vendor jQuery DOM 操作
//      (`this.$().hide().css('bottom', ...)` 会 jQuery hide 我们 vnode 根 div, 不好),
//      vendor state machine (state.isVisible / state.position) 仍然 work
//   3. 防御性 super-call: 桌面端 (>= 992px) return original.call(this) 走 vendor
//   4. 移动端: 完全重写 vnode, 不显示 vendor Composer 任何内容
//   5. active class 状态: 我们 vnode input/textarea onfocus 调 this.active = true + m.redraw
//   6. 发送按钮: 走 hidden ComposerBody instance.onsubmit() (我们在 hidden vnode
//      实例化 ComposerBody, oncreate 时拿 vnode.state instance 引用)
//   7. fof/bookmarks 检测: 走 app.forum.attribute('fof-bookmarks') / 'canBookmark'
//
// 风险 (跟 zpc e.k + e.k.1 + e.k.2 实战踩过坑一致):
//   - vendor Composer mithril 渲染时写 inline `style="top:0;bottom:0;height:350px"`
//     覆盖 CSS !important (SOP 283). 修法: 块内加 `top: auto !important;` 覆盖
//     inline top. 768-991 iPad portrait 范围 vendor @media @phone shim 不匹配
//     (SOP 282), 必显式 `position: fixed !important;`
//   - 弹键盘逻辑: vendor 自带 iOS 软键盘, composer 仍 fixed bottom, keyboard 从
//     下方推上, content 滚动避开. 用 window.visualViewport.resize 监听调整 composer bottom
//   - ComposerBody 是 vendor abstract class, 我们用 state.body.componentClass (具体子类)
//   - 跟 zpc 兼容: zpc e.h.a 接管了 ComposerBody.onsubmit 加 parentPost 关系. zpc
//     revert 后 zpc 不在. 但本扩展只关心 vendor 默认 onsubmit 路径, 走我们的 hidden
//     ComposerBody instance.onsubmit() 自动兼容 (zpc 重新启用时只需把 instance 引用
//     共享给 zpc 即可)
//
// 验证模式 (Mavis 跑, 4 viewport × 4 case = 16 测试, 期望全 PASS):
//   T16: default 状态 (mobile-390x844 / ipad-portrait-768x1024)
//        height ≈ 80px, "来说点什么吧!" + 2 action, vendor 元素全 hidden
//   T17: focused 状态 (mobile-390x844 / ipad-portrait-768x1024)
//        height ≈ 140px, 4 input-tool + 8 emoji, vendor 元素全 hidden
//   T18: composer 钉 viewport 底 (mobile / ipad-portrait)
//        gap=0, composerBottom = viewport height
//   T19: MobileTab hidden 不破 (跟 v0.2.5e.1 配套, body:has(.DiscussionPage) .MobileTab display:none)
//   T20: IndexPage 不弹 composer (回归)
//   桌面端 (ipad-landscape-1024x768 / desktop-1440x900): hasZivenClass=false, 走 vendor
// ====================================================================

import app from 'flarum/common/app';
import { override } from 'flarum/common/extend';
// mithril 是 vendor 注入的 free variable `m` (跟 buildElements.js / modifyDrawer.js
// 同款, Flarum 2.0 vendor 启动时设 `window.m = mithril` 在 forum bundle 加载),
// 不 import, 直接 free variable 引用

// === 移动端检测 ===
const isMobile = () => typeof window !== 'undefined' && window.innerWidth < 992;

// === fof/bookmarks 检测 (辉哥: "fof/bookmarks 装了才显示 .optional class") ===
// v0.2.5f.d 修法: fof-bookmarks vendor 在 forum attribute 用 dot notation 注册
// (e.g. 'fof-bookmarks.independentButton' / 'fof-bookmarks.postButtonPosition' /
//  'fof-bookmarks.postHeaderBadge'), 不是 'fof-bookmarks' / 'canBookmark' / 'bookmarks'.
// 之前 v0.2.5f 用错 key 导致永远 false, fof-bookmarks 装了也显示不出来.
const hasFofBookmarks = () => {
  if (typeof app === 'undefined' || !app.forum) return false;
  const attrs = app.forum.data && app.forum.data.attributes || {};
  return 'fof-bookmarks.independentButton' in attrs || 'fof-bookmarks.postButtonPosition' in attrs || 'fof-bookmarks.postHeaderBadge' in attrs;
};

// === 拿当前主楼 post 引用 (辉哥 08:50 调研给的路径) ===
// vendor Composer body 是 DiscussionComposer, state.body.attrs 含 discussion
// (state.body 是 plain object { componentClass, attrs }, attrs 是 ComposerBody attrs)
// 当前主楼 post: state.body.attrs.parentPost (楼中楼有) || discussion.firstPost() || discussion.posts()[0]
// zpc v0.1.0e 已 revert 不参与, 我们直接读 vendor Composer state
const getCurrentPost = state => {
  const attrs = state.body && state.body.attrs || {};
  if (attrs.parentPost) return attrs.parentPost;
  const discussion = attrs.discussion;
  if (!discussion) return null;
  if (typeof discussion.firstPost === 'function') {
    return discussion.firstPost() || null;
  }
  if (typeof discussion.posts === 'function') {
    return discussion.posts()[0] || null;
  }
  return null;
};

// === 8 emoji (辉哥设计 v4 emoji 工具条) ===
const ZIVEN_COMPOSER_EMOJIS = ['😊', '😢', '😨', '🤔', '😱', '😺', '🥵', '🧢'];

// === 默认 placeholder 文本 ===
const ZIVEN_COMPOSER_PLACEHOLDER = '来说点什么吧!';

// === vendor ComposerBody instance 引用 (oncreate 时挂到 state.__auraComposerBody) ===
const getComposerBodyInstance = state => state && state.__auraComposerBody;

// === vendor Composer state fields.content Stream ===
const getContent = state => {
  const fields = state.fields;
  return fields && fields.content ? fields.content() : '';
};
const setContent = (state, value) => {
  const fields = state.fields;
  if (fields && fields.content) fields.content(value);
};

// === 构建 default 状态 vnode (80px) ===
// v0.2.5f.d 修法: 真实 like + bookmark 集成 (辉哥 08:50 反馈数字写死 + bookmark 误判)
// - 👍 走 vendor likes API: post.likesCount() / post.attribute('isLiked') / post.save({isLiked})
// - ⭐ 走 vendor fof-bookmarks API: post.bookmarked() / post.save({bookmarked})
// - 当前主楼 post 引用: state.body.attrs.parentPost || discussion.firstPost() || discussion.posts()[0]
const buildDefaultVnode = state => {
  const fofBookmarks = hasFofBookmarks();
  const post = getCurrentPost(state);
  const likesCount = post && typeof post.likesCount === 'function' ? post.likesCount() : 0;
  const isLiked = post && typeof post.attribute === 'function' ? !!post.attribute('isLiked') : false;
  const isBookmarked = post && typeof post.bookmarked === 'function' ? !!post.bookmarked() : false;
  const canLike = post && typeof post.canLike === 'function' ? post.canLike() : false;
  return m('div', {
    className: 'ziven-composer-default-wrap'
  },
  // 输入框 pill (clickable, 触发 vendor composer focus)
  m('div', {
    className: 'ziven-composer-pill',
    onclick: () => {
      // 触发 vendor composer focus → vendor Composer instance.active = true
      // 实际上 vendor Composer 自己监听 :input focus 设 this.active, 我们没渲染 vendor ComposerBody
      // 所以我们自己设 this.active
      const composer = state && state.composerRef || null;
      if (composer) {
        composer.active = true;
        if (typeof m !== 'undefined' && m.redraw) m.redraw();
      }
    }
  }, ZIVEN_COMPOSER_PLACEHOLDER),
  // action 1: 👍 点赞 (真实 vendor likes API, 不是 hardcoded 1313)
  m('button', {
    className: 'ziven-composer-action ziven-composer-action--like' + (isLiked ? ' is-active' : ''),
    type: 'button',
    title: '点赞',
    disabled: !canLike,
    onclick: e => {
      e.preventDefault();
      if (!post || typeof post.save !== 'function') return;
      const newState = !isLiked;
      // vendor likes API: post.save({isLiked: true/false}) 走 PATCH /api/posts/:id
      // vendor likes model 自动同步 likesCount + likes() relationship
      post.save({
        isLiked: newState
      }).then(() => {
        if (typeof m !== 'undefined' && m.redraw) m.redraw();
      }).catch(() => {
        // 静默 fail, UI 状态回滚
      });
    }
  }, m('i', {
    className: isLiked ? 'fas fa-thumbs-up' : 'far fa-thumbs-up'
  }), m('span', {
    className: 'ziven-composer-action-count'
  }, String(likesCount))),
  // action 2: ⭐ 书签 (vendor fof-bookmarks API, 装了才显示, 无 count)
  // v0.2.5f.i: 视觉对齐 👍 button, 内部加 hidden count placeholder (fof-bookmarks
  // 是 per-user 不像 likes per-post, 无 count 显示, 但 2 button 内部 structure
  // 不一致会让 icon y 位置错位. 跟 👍 button 内部 icon + count 上下 structure 一致
  // 让 2 button 高度 + icon y 位置对齐)
  fofBookmarks ? m('button', {
    className: 'ziven-composer-action ziven-composer-action--bookmark' + (isBookmarked ? ' is-active' : ''),
    type: 'button',
    title: '书签',
    onclick: e => {
      e.preventDefault();
      if (!post || typeof post.save !== 'function') return;
      const newState = !isBookmarked;
      // vendor fof-bookmarks API: post.save({bookmarked: true/false}) 走 PATCH /api/posts/:id
      post.save({
        bookmarked: newState
      }).then(() => {
        if (typeof m !== 'undefined' && m.redraw) m.redraw();
      }).catch(() => {
        // 静默 fail
      });
    }
  }, m('i', {
    className: isBookmarked ? 'fas fa-star' : 'far fa-star'
  }),
  // hidden count placeholder (visual alignment 跟 👍 button 内部 structure 一致)
  m('span', {
    className: 'ziven-composer-action-count'
  }, '\u00A0')) : null);
};

// === 构建 focused 状态 vnode (140px) ===
// v0.2.5f.f 修法: 改用 vendor ComposerBody 渲染, 保留 vendor 完整集成
// (vendor TextEditor 自带 @mention autocomplete / emoji picker / fof/upload / vendor submit).
// 之前 v0.2.5f 自建 <textarea> 替代 vendor TextEditor, 失去 vendor 完整功能.
// 现在 ziven focused 状态直接 m(ComposerBodyClass, { ...attrs, composer: state, disabled: false })
// 渲染 vendor ComposerBody, 4 input-tool 协调 vendor 行为.
const buildFocusedVnode = state => {
  const ComposerBodyClass = state.body && state.body.componentClass || null;
  const composerBodyInstance = getComposerBodyInstance(state);
  // canSend 看 vendor ComposerBody composer.fields.content (跟 vendor 一致, 不看自建 textarea)
  const canSend = composerBodyInstance && composerBodyInstance.composer ? ((composerBodyInstance.composer.fields && composerBodyInstance.composer.fields.content ? composerBodyInstance.composer.fields.content() : '') || '').trim().length > 0 : false;
  return m('div', {
    className: 'ziven-composer-focused-wrap'
  },
  // vendor ComposerBody 渲染 (vendor TextEditor + @mention autocomplete + emoji picker + fof/upload)
  // oncreate 时把 instance 挂到 state.__auraComposerBody, 4 input-tool 跟发送按钮拿引用
  // v0.2.5f.h: 移除 onTextEditorBuilt 接管, 让 vendor 走默认 (m() 没传 attr 走 prototype method).
  // 之前 onTextEditorBuilt: () => {} 让 vendor textEditorBuilt 永远 false + resolveEditorReady 不跑,
  // vendor TextEditor 不 ready, mention autocomplete / emoji picker / 等都没初始化
  // (Puppeteer debug 测出: 输 @ 后 vendor Dropdown-menu DOM 存在但 visibility:hidden, height:0).
  // 跟 zpc v0.1.0e.h.a 实战一致: zpc 接管 onsubmit 加 parentPost, onTextEditorBuilt 走 vendor 默认.
  ComposerBodyClass ? m(ComposerBodyClass, _objectSpread(_objectSpread({}, state.body && state.body.attrs || {}), {}, {
    composer: state,
    disabled: false,
    oncreate: vnode => {
      if (vnode && vnode.state) {
        state.__auraComposerBody = vnode.state;
      }
    }
  })) : null,
  // 4 input-tool bar (内嵌右下, 辉哥 v4 设计, 协调 vendor TextEditor-toolbar)
  m('div', {
    className: 'ziven-composer-input-tool-row'
  },
  // emoji 按钮: 调 vendor TextEditor-toolbar 内的 emoji button (flarum/emoji 装了就 work)
  m('button', {
    className: 'ziven-composer-tool ziven-composer-tool--emoji',
    type: 'button',
    title: '表情',
    onclick: e => {
      e.preventDefault();
      const editor = composerBodyInstance && composerBodyInstance.editor;
      if (editor) {
        // jQuery 找 vendor TextEditor-toolbar 内的 emoji button click
        const jq = typeof window !== 'undefined' && window.jQuery || typeof $ !== 'undefined' && $;
        if (jq) {
          const emojiBtn = jq('.Composer.active.visible .TextEditor-toolbar .Button--icon[aria-label*="emoji"], .Composer.active.visible .TextEditor-toolbar .Button--icon[aria-label*="Emoji"]').first();
          if (emojiBtn.length) {
            emojiBtn[0].click();
            return;
          }
        }
      }
      // fallback: 直接插入 😀 到 content (vendor emoji 没装 或 button 没找到)
      if (state.fields && state.fields.content) {
        state.fields.content(state.fields.content() + '😀');
      }
    }
  }, m('i', {
    className: 'fas fa-face-smile'
  })),
  // upload 按钮: 调 vendor TextEditor-toolbar 内的 fof/upload button
  m('button', {
    className: 'ziven-composer-tool ziven-composer-tool--upload',
    type: 'button',
    title: '图片',
    onclick: e => {
      e.preventDefault();
      const editor = composerBodyInstance && composerBodyInstance.editor;
      const jq = typeof window !== 'undefined' && window.jQuery || typeof $ !== 'undefined' && $;
      if (jq) {
        const uploadBtn = jq('.Composer.active.visible .TextEditor-toolbar .Button--icon[aria-label*="upload"], .Composer.active.visible .TextEditor-toolbar .Button--icon[aria-label*="Upload"], .Composer.active.visible .TextEditor-toolbar .Button--icon[aria-label*="图片"]').first();
        if (uploadBtn.length) {
          uploadBtn[0].click();
        }
      }
      // fof/upload 没装或 button 没找到: 静默 (no-op)
    }
  }, m('i', {
    className: 'fas fa-image'
  })),
  // mention 按钮: focus vendor TextEditor + 触发 @ 字符让 vendor mention autocomplete 弹
  m('button', {
    className: 'ziven-composer-tool ziven-composer-tool--mention',
    type: 'button',
    title: '@用户',
    onclick: e => {
      e.preventDefault();
      const editor = composerBodyInstance && composerBodyInstance.editor;
      // 1. focus vendor TextEditor (cursor 进去)
      if (editor && typeof editor.focus === 'function') {
        editor.focus();
      } else {
        // fallback: 找 vendor TextEditor 的 textarea 直接 focus
        const jq = typeof window !== 'undefined' && window.jQuery || typeof $ !== 'undefined' && $;
        if (jq) {
          const ta = jq('.Composer.active.visible .TextEditor-editorContainer textarea, .Composer.active.visible .TextEditor-editor').first();
          if (ta.length) ta[0].focus();
        }
      }
      // 2. 在 cursor 处插入 @ (vendor mention autocomplete 监听 textarea 变化, 自动弹用户选择列表)
      if (state.fields && state.fields.content) {
        state.fields.content(state.fields.content() + '@');
      }
    }
  }, m('i', {
    className: 'fas fa-at'
  })),
  // 发送按钮 (辉哥 v4: 蓝色圆角填充, "发送" 文字, 60x30, 圆角 16px)
  // 走 vendor ComposerBody.onsubmit (vendor ReplyComposer.onsubmit 走 PATCH /api/posts)
  m('button', {
    className: 'ziven-composer-send' + (canSend ? '' : ' is-disabled'),
    type: 'button',
    title: '发送',
    onclick: e => {
      e.preventDefault();
      if (!canSend) return;
      if (composerBodyInstance && typeof composerBodyInstance.onsubmit === 'function') {
        composerBodyInstance.onsubmit();
      } else if (state.body && state.body.attrs && state.body.attrs.discussion) {
        // fallback: 走 vendor API 直接 save post (走 app.store.createRecord('posts').save())
        const discussion = state.body.attrs.discussion;
        const data = {
          content: state.fields && state.fields.content ? state.fields.content() : '',
          relationships: {
            discussion
          }
        };
        if (typeof app !== 'undefined' && app.store) {
          app.store.createRecord('posts').save(data).then(() => {
            if (typeof app !== 'undefined' && app.composer) app.composer.hide();
            if (state.fields && state.fields.content) state.fields.content('');
          });
        }
      }
    }
  }, '发送')),
  // 8 emoji 工具条 (辉哥 v4: 32x32 圆角 8px 横排可滚动)
  // 走 vendor composer.fields.content 插入文本, vendor TextEditor 自动 sync
  m('div', {
    className: 'ziven-composer-emoji-bar'
  }, ZIVEN_COMPOSER_EMOJIS.map(emoji => m('button', {
    className: 'ziven-composer-emoji',
    type: 'button',
    onclick: e => {
      e.preventDefault();
      if (state.fields && state.fields.content) {
        state.fields.content(state.fields.content() + emoji);
      }
    }
  }, emoji))));
};

// === 移动端 vnode 顶层 ===
const buildMobileVnode = composer => {
  const state = composer.state;
  // 把 composer instance 挂到 state, 方便 oncreate 回调拿
  if (state && !state.composerRef) state.composerRef = composer;
  const isFocused = Boolean(composer.active);
  const isVisible = state.isVisible();
  const content = getContent(state);
  return m('div', {
    className: 'Composer' + ' ziven-composer-mobile' + (isFocused ? ' ziven-composer-focused' : ' ziven-composer-default') + (isVisible ? ' visible' : ' hidden') + (content ? ' has-content' : '')
  }, isFocused ? buildFocusedVnode(state) : buildDefaultVnode(state));
};

// === 注册 mobileComposer ===
export default function mobileComposer() {
  const flarumReg = typeof window !== 'undefined' && window.flarum && window.flarum.reg || null;
  if (!flarumReg) {
    // mavis context: flarumReg not available, 静默 fail, 桌面端走 vendor 默认
    return;
  }
  flarumReg.onLoad('core', 'forum/components/Composer', mod => {
    const Composer = mod && mod.default ? mod.default : mod;
    if (!Composer) return;
    // Idempotent: 多次 init 不叠加 extend (HMR / 重 init 保护)
    if (Composer.prototype.__auraMobileComposed) return;
    Composer.prototype.__auraMobileComposed = true;

    // 1. override Composer.view: 桌面端走 vendor, 移动端走我们
    override(Composer.prototype, 'view', function (original) {
      // 防御性 super-call: vendor view() 仍跑拿 vendor state machine 状态
      // (虽然我们不返 vendor vnode, 但保证 vendor 内部 self.state 更新)
      const vendorVnode = original ? original.call(this) : null;
      if (!isMobile()) {
        return vendorVnode;
      }
      // 移动端: 我们的 vnode
      return buildMobileVnode(this);
    });

    // 2. override Composer.oncreate: 跳过 vendor jQuery DOM 操作
    // vendor Composer.oncreate 调 this.$().hide().css('bottom', ...) 会 jQuery hide 我们 vnode 根 div
    // vendor Composer state machine (state.isVisible / state.position / this.active) 仍然 work
    override(Composer.prototype, 'oncreate', function () {
      // 跳过 vendor Composer oncreate 全部 jQuery DOM 操作
      // vendor state machine (state.isVisible / state.position) 仍 work, vendor Composer instance 仍存在
    });
  });

  // === 3. v0.2.5f.c: mobile + DiscussionPage 范围主动 force vendor composer show ===
  // 辉哥 08:46 反馈: 进入帖子后下方输入框不会立刻展现出来, 而是要点击 vendor
  // "说点什么吧..." (jQuery 残留 DOM) 之后才会显示. 实际 vendor Composer state
  // 默认 position: "hidden", isVisible: false, DOM 0 个 .Composer 元素.
  //
  // 期望: 进入 /d/:id, 移动端 (< 992px) 主动 force vendor composer show, 走 ziven
  // vnode (default 80px state) 立即渲染, 不需要先点 vendor 残留 DOM.
  //
  // v0.2.5f.e 修法: 之前 v0.2.5f.c 直接 app.composer.show(), 但 vendor Composer
  // state.body 默认 {attrs: {}} (vendor ComposerState.tsx line 121 clear() 默认),
  // 没 load componentClass, state.body.attrs.discussion / parentPost 都 undefined,
  // 我们 ziven getCurrentPost() 拿不到 post 引用, like/bookmark vendor API 走不通.
  //
  // 修法: 走 vendor API load() + show() 双步:
  //   1. 拿当前 discussion 引用 (DiscussionPage mounted 时设 app.current.discussion)
  //   2. app.composer.load(() => flarum.reg.asyncModuleImport('flarum/forum/components/ReplyComposer'),
  //      {discussion: currentDiscussion}) - 触发 vendor ReplyComposer chunk lazy load
  //      + 设 state.body.attrs.discussion
  //   3. load() 完调 app.composer.show() - 走 vendor Composer render
  //   4. ziven override Composer.view 接 vendor Composer render, 走 ziven vnode,
  //      ziven getCurrentPost(state) 现在能拿到 post (discussion.firstPost())
  //
  // 时序: setTimeout 300ms 是给 vendor Composer chunk (chunk 366 module 8139) lazy
  // load 留时间, 我们的 override Composer.view 注册后才能接 vendor Composer render.
  if (isMobile()) {
    const checkAndShow = () => {
      // mobile 范围 + DiscussionPage 范围 + vendor composer 还没 visible
      if (typeof window !== 'undefined' && window.app && window.app.composer && document.querySelector('.DiscussionPage') && !window.app.composer.isVisible()) {
        // 拿当前 discussion 引用 (DiscussionPage mounted 时设 app.current.discussion)
        let discussion = null;
        try {
          if (window.app.current && typeof window.app.current.get === 'function') {
            discussion = window.app.current.get('discussion');
          }
        } catch (err) {
          // 静默 fail
        }
        if (!discussion) {
          // 还没加载完, 静默 fail (下次 setTimeout / route set 会再试)
          return;
        }
        // 走 vendor API: load vendor ReplyComposer chunk + 传 discussion attrs
        // 触发 vendor ReplyComposer chunk lazy load, 之后 state.body.attrs.discussion 设上
        // webpack 静态 import 不行, 必走 dynamic import () => import(...) 才能 lazy load chunk
        try {
          const loadPromise = window.app.composer.load(() => flarum.reg.asyncModuleImport('flarum/forum/components/ReplyComposer'), {
            discussion
          });
          if (loadPromise && typeof loadPromise.then === 'function') {
            loadPromise.then(() => {
              // load 完调 show (走 vendor 内部 state machine,
              // state.position NORMAL + state.isVisible true)
              try {
                window.app.composer.show();
              } catch (err) {
                // 静默 fail
              }
            }).catch(() => {
              // load fail 静默
            });
          } else {
            // 同步路径 (老 vendor API) 直接 show
            window.app.composer.show();
          }
        } catch (err) {
          // 静默 fail, 走 vendor 默认
        }
      }
    };
    // 1) init 300ms 后检查 (DiscussionPage 可能已加载, 300ms 足够 vendor Composer chunk lazy load)
    setTimeout(checkAndShow, 300);
    // 2) 监听 mithril route change (SPA 跳 /d/:id)
    const win = typeof window !== 'undefined' ? window : null;
    if (win && win.m && win.m.route) {
      const origSet = win.m.route.set;
      if (origSet && !origSet.__auraForceShow) {
        const wrapped = function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          const result = origSet.apply(this, args);
          setTimeout(checkAndShow, 100);
          return result;
        };
        wrapped.__auraForceShow = true;
        win.m.route.set = wrapped;
      }
    }
    // 3) 监听 history popstate (浏览器 back/forward)
    if (win) {
      win.addEventListener('popstate', () => setTimeout(checkAndShow, 100));
    }
  }
}